<h1 matDialogTitle>{{data?.dialogTitle}}</h1>

<mat-dialog-content>
  <div *ngIf="data.dialogText" class="dialog-text">{{data.dialogText}}</div>
  <ng-container *ngIf="data?.formFields; then formTemplate; else noFromTemplate"></ng-container>
  <ng-template #formTemplate>
    <optsol-ngx-dynamic-form *ngIf="data?.formFields" [fields]="data.formFields" [initialValue]="data.initialFormValue"
      [fxLayout]="data.fxLayout" [fxLayoutAlign]="data.fxLayoutAlign" [fxLayoutGap]="data.fxLayoutGap">
    </optsol-ngx-dynamic-form>
  </ng-template>
  <ng-template #noFromTemplate>
    <div *ngIf="!data.dialogText">No form fields or dialog text received.</div>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button matDialogClose [disabled]="apiCallInProgress">Cancel</button>
  <ng-container *ngIf="data.buttons; else noButtons">
    <button *ngFor="let button of data.buttons" [disabled]="!formValid || apiCallInProgress" mat-raised-button [color]="button.color || 'primary'" (click)="submit(button.value)">{{button.buttonText}}</button>
  </ng-container>
  
  <ng-template #noButtons>
    <button [disabled]="!formValid || apiCallInProgress" mat-raised-button color="primary" (click)="submit(null)">OK</button>
  </ng-template>
</mat-dialog-actions>